import { SubscriptionPlans } from "../../constant-value/SubscriptionPlans.js";

export const SubscriptionPolicy = {

    [SubscriptionPlans.FREE]:{

        attachments:10,

        cars:1,

        services:1,

        reminders:5,

        expenses:Number.MAX_SAFE_INTEGER,

    },

    [SubscriptionPlans.TRIAL]:{

        attachments:Number.MAX_SAFE_INTEGER,

        cars:Number.MAX_SAFE_INTEGER,

        services:Number.MAX_SAFE_INTEGER,

        reminders:Number.MAX_SAFE_INTEGER,

        expenses:Number.MAX_SAFE_INTEGER,

    },

    [SubscriptionPlans.PRO]:{

        attachments:Number.MAX_SAFE_INTEGER,

        cars:Number.MAX_SAFE_INTEGER,

        services:Number.MAX_SAFE_INTEGER,

        reminders:Number.MAX_SAFE_INTEGER,

        expenses:Number.MAX_SAFE_INTEGER,

    },

};
